import MarkdownDoc from "../components/MarkdownDoc";
import { Question } from "@phosphor-icons/react";
import { api } from "../lib/api";

export default function GuidePage() {
  return (
    <MarkdownDoc
      title="Guide"
      icon={Question}
      intro="Step-by-step user guide — how to do everything in MediHub."
      loader={api.guide}
      testIdPrefix="guide"
    />
  );
}
